import { render, staticRenderFns } from "./KegiatanUsahaUtama.vue?vue&type=template&id=7000448e&"
import script from "./KegiatanUsahaUtama.vue?vue&type=script&lang=js&"
export * from "./KegiatanUsahaUtama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports